import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IServiceResponse } from '../models/service.model';
import { ROUTES } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class SiteService {
  constructor(
    private httpClient: HttpClient
  ) {}

  /**
   * Get all site
   * @returns
   */
  gets(): Observable<IServiceResponse> {
    return this.httpClient.get<IServiceResponse>(`${ROUTES.site.list}`);
  }

  /**
   * Get one site
   * @returns
   */
  get(id: number): Observable<IServiceResponse> {
    return this.httpClient.get<IServiceResponse>(`${ROUTES.offre.one}/${id}`);
  }
}
